import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Check = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 12.893 5.286 5.286L20.5 6.322"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Check) as SvgIcon;
export { ForwardRef as ReactComponent };
